<template>
  <div>
    <div>
      <div class="title mb-2">Filtrar resultados</div>
      <div v-if="filtersFields" class="principal">
        <div>
          <!-- CAMPO -->
          <Dropdown
            dataKey="name"
            id="dropdown"
            v-model="field"
            :options="filtersFields"
            optionLabel="name"
            placeholder="en"
            class="mr-2 mb-2 field p-inputtext-sm"
            :filter="filtersFields?.length >= 5"
            ref="TTableFiltersFiledRef"
            :disabled="filterChipCount >= 4"
          />
        </div>
        <div v-if="!field?.hideOperators">
          <!-- OPERADOR -->
          <Dropdown
            dataKey="value"
            id="dropdown"
            v-model="operator"
            :options="activeOperators"
            class="mr-2 mb-2 p-inputtext-sm"
            optionLabel="type"
            placeholder="IGUAL A"
            :filter="activeOperators?.length >= 5"
            :disabled="filterChipCount >= 4"
          />
        </div>
        <div v-if="operator && !operator.last">
          <MultiSelect
            v-if="dropdown[field.field] && field.multiple"
            :filter="dropdown[field.field]?.options?.length >= 5"
            v-model="value"
            :options="dropdown[field.field].options"
            :optionLabel="dropdown[field.field].optionLabel"
            class="mr-2 p-inputtext-sm w-11rem"
            @hide="onDropdownHide('MultiSelectRef')"
            ref="MultiSelectRef"
            style="height: 37px"
            :disabled="filterChipCount >= 4"
          />
          <!-- VALOR -->
          <Dropdown
            test-id="DropFiltros"
            v-else-if="dropdown[field.field] && !field.multiple"
            v-model="value"
            :options="getValueOptions(field.field)"
            @change="() => changeDropdown(field.field)"
            :optionLabel="dropdown[field.field].optionLabel"
            :dataKey="dropdown[field.field].optionValue"
            class="mr-2 p-inputtext-sm"
            :filter="getValueOptions(field.field)?.length >= 5"
            @hide="onDropdownHide('DropFiltros')"
            ref="DropFiltros"
            :disabled="filterChipCount >= 4"
          >
          </Dropdown>
          <Calendar
            v-else-if="field.type == 'date' || field.type == 'dateOnlyRange'"
            class="mr-2 mb-2 p-inputtext-sm"
            inputClass="p-inputtext-sm"
            className="p-inputtext-sm"
            v-model="value"
            dateFormat="dd/mm/yy"
            placeholder="Fecha..."
            onkeydown="return false"
            test-id="calendar"
            showIcon
          />

          <InputText
            v-else-if="!field?.hideValue"
            :placeholder="field.name + '...'"
            v-model="value"
            class="mr-2 p-inputtext-sm"
            :test-id="value"
            :disabled="filterChipCount >= 4"
          />

          <!-- Datos Espesificos para filtros que refieren a datos de otras Tablas -->
          <InputText
            v-if="value?.type == 'inputEspecific'"
            :placeholder="value.name + '...'"
            v-model="value2"
            class="mr-2 p-inputtext-sm"
            :test-id="value.name"
          />

          <!-- El siguiente Dropdon buscara sus options en la Prop efectos con la key que se arma del nombre de la tabla y el nombre del campo con el que se va a realizar el filtro -->
          <Dropdown
            test-id="DropFiltros"
            v-if="value?.type == 'dropdownEspecific'"
            v-model="value2"
            :options="
              deleteNullProps(dropdown[value?.value]?.options, dropdown[value?.value]?.optionLabel)
            "
            @change="() => changeDropdown(value?.value)"
            :optionLabel="dropdown[value?.value]?.optionLabel"
            :dataKey="dropdown[value?.value]?.optionValue"
            class="mr-2 p-inputtext-sm"
            filter
          >
          </Dropdown>
        </div>
        <div style="display: flex">
          <!-- botonos izquierda -->
          <Button
            v-if="enableFilterMultiple && filterChipCount < 4"
            class="search-button flex-grow-0"
            @click="handleFilterAction()"
            id="boton-filtro"
            test-id="boton-agregar-filtro"
            ref="filterButton"
            :disabled="filterChipCount >= 4 || isLoading"
          >
            <div>
              <Search color="white" :size="20" />
            </div>
            Buscar
          </Button>
          <CustomTooltip
            v-else
            :text="'El limite de filtro a aplicar son 4'"
            placement="top"
            style="width: auto"
          >
            <Button
              v-if="enableFilterMultiple"
              class="search-button flex-grow-0"
              @click="handleFilterAction()"
              id="boton-filtro"
              test-id="boton-agregar-filtro"
              ref="filterButton"
              :disabled="filterChipCount >= 4 || isLoading"
            >
              <div>
                <Search color="white" :size="20" />
              </div>
              Buscar
            </Button>
          </CustomTooltip>
          <Button
            v-if="filters.length > 0"
            class="clean-button flex-grow-0"
            @click="cleanFilter"
            :disabled="isLoading"
            test-id="cleanFilter"
          >
            <div>
              <BrushCleaning color="#0B5195" :size="20" />
            </div>
            {{ alternativeStylesCleanButton ? "Limpiar" : "Limpiar Filtro" }}
          </Button>
        </div>
      </div>
      <div class="itemSelect mt-2 flex" v-if="enableFilterMultiple">
        <div v-for="item in filters.slice(0, 4)" :key="item.id" id="filterSelec" class="mr-2 mb-2">
          <Chip
            v-if="item?.operator?.type"
            class="filter-item"
            :label="`${item.field.name} ${item.operator.type.toLowerCase()} ${getValueName(filters.findIndex((f) => f.id === item.id))}`"
            :removable="!isLoading"
            @remove="removeFilter(item.id)"
            :disabled="isLoading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, getCurrentInstance, defineExpose, computed } from "vue";
import { useDate } from "@/composables/useDate";
import { useToast } from "@/composables/index.js";
import { Search, BrushCleaning } from "lucide-vue";

const props = defineProps({
  filtersFields: { type: Array, default: () => [] },
  dropdown: { type: Object, default: () => ({}) },
  apiversion: { type: String },
  enableFilterMultiple: { type: Boolean, default: false },
  alternativeStylesCleanButton: { type: Boolean, default: false },
  isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(["search"]);

const { appContext } = getCurrentInstance();

const { dateFromString, esCalendar2Sql, esCalendar2SqlFechaHasta } = useDate();

const field = ref(null);
const operator = ref(null);
const value = ref(null);
const value2 = ref(null);
const filters = ref([]);
const toast = useToast();

const filterChipCount = computed(() => (Array.isArray(filters.value) ? filters.value.length : 0));

const operators = ref({
  default: [
    { value: "=", type: "IGUAL" },
    { value: "!=", type: "DISTINTO" },
    { value: "CONTAINS", type: "CONTIENE" },
    { value: ">", type: "MAYOR QUE" },
    { value: ">=", type: "MAYOR O IGUAL QUE" },
    { value: "<", type: "MENOR QUE" },
    { value: "<=", type: "MENOR O IGUAL QUE" },
  ],
  multiple: [{ value: "IN", type: "INCLUIR" }],
  multipleDays: [{ value: "LAST_DAYS", type: "INCLUIR" }],
  total: [{ value: "IS NOT NULL", type: "Todas", last: true }],
  date: [
    { value: "TODAY", type: "Hoy", last: true },
    { value: "YESTERDAY", type: "Ayer", last: true },
    { value: ">=", type: "Desde" },
    { value: "<=", type: "Hasta" },
    { value: "THIS_WEEK", type: "Esta Semana", last: true },
    { value: "THIS_MONTH", type: "Este Mes", last: true },
    { value: "THIS_YEAR", type: "Este Año", last: true },
  ],
  dateOnlyRange: [
    { value: ">=", type: "Desde" },
    { value: "<=", type: "Hasta" },
  ],
});
const activeOperators = ref([]);

/** Helpers */
function getOperators(field) {
  let list = operators.value["default"];
  if (field.type && operators.value[field.type]) {
    list = operators.value[field.type];
  }

  operator.value = list[0];
  return list;
}

function getUniqueOptions(options, propertyName) {
  const uniqueOptions = [];
  const seenValues = new Set();

  if (!options || !Array.isArray(options)) {
    console.warn("getUniqueOptions: Invalid options input. Returning an empty array.");
    return [];
  }
  for (const option of options) {
    if (option && typeof option === "object" && option.hasOwnProperty(propertyName)) {
      const value = option[propertyName];
      if (!seenValues.has(value)) {
        uniqueOptions.push(option);
        seenValues.add(value);
      }
    }
  }
  return uniqueOptions;
}

function cloneObj(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function changeDropdown(field) {
  if (!props.dropdown[field] || !props.dropdown.changeDropdown) return;
  //si no existe un valor
  if (typeof value.value == "undefined") return;
  props.dropdown[field].changeDropdown(cloneObj(value.value), cloneObj(filters.value));
}

function limpiaForm() {
  value.value = null;
  value2.value = null;
}

async function handleFilterAction() {
  if (props.enableFilterMultiple) {
    await addFilter();
  }
  emit("search");
}

async function addFilter() {
  //si esta vacio termina
  if ((!value.value || value.value == "") && (!operator.value || !operator.value.last)) return;
  // si ya esa al limite termina
  if (hasLimit()) return;
  if (!checkFiltersCompatibility()) return;
  // para fechas agregas ejecuta addDateFilter
  if (field.value.type == "date" || field.value.type == "dateOnlyRange") {
    await addDateFilter();
    // limpia filtro
    if (props.enableFilterMultiple) limpiaForm();
    return;
  }
  // Crear el filtro
  const newFilter = {
    id: Date.now() + Math.random(),
    field: cloneObj(field.value),
    operator: cloneObj(operator.value),
    value: cloneObj(value.value),
  };

  // Verificar duplicados
  const exists = filters.value.some(
    (filter) =>
      filter.field.name === newFilter.field.name &&
      filter.operator.type === newFilter.operator.type &&
      filter.value === newFilter.value
  );

  if (!exists) {
    filters.value.push(newFilter);
  } else {
    console.error("El filtro no se agregó porque ya existe");
  }
  if (props.enableFilterMultiple) limpiaForm();
  // await this.runFilters()
}

/** Watchers */
watch(field, (v) => {
  activeOperators.value = cloneObj(getOperators(v));
  value.value = null;
  value2.value = null;
});

function validateDates(dateArray) {
  const dates = {};
  dateArray.forEach((item) => {
    const date = parseDate(item.valueView);
    if (!date) return; // Ignore invalid dates
    if (!dates[item.operator.type]) {
      dates[item.operator.type] = [];
    }
    dates[item.operator.type].push(date);
  });
  // Get the max "From" date and the min "To" date
  const minToDate = dates["Hasta"] ? Math.min(...dates["Hasta"]) : null;
  const maxFromDate = dates["Desde"] ? Math.max(...dates["Desde"]) : null;
  // Check for contradiction
  if (maxFromDate !== null && minToDate !== null && maxFromDate > minToDate) {
    return false; // Contradiction detected
  }
  return true; // No contradictions
}

function parseDate(dateStr) {
  if (dateStr === undefined) return;
  const [day, month, year] = dateStr.split("/").map(Number);
  return new Date(year, month - 1, day).getTime();
}

watch(
  filters,
  (newValue) => {
    const hasDateOperators = newValue?.some(
      (item) => item?.operator?.type === "Desde" || item?.operator?.type === "Hasta"
    );
    if (hasDateOperators) {
      if (!validateDates(newValue)) {
        filters.value = [];
        toast.error_right("La fecha de inicio no puede ser mayor que la fecha de fin.");
      }
    }
  },
  { deep: true }
);

/** Init */
onMounted(() => {
  field.value = props.filtersFields[0];
});

// Acceso a $refs en Composition
const vm = getCurrentInstance()?.proxy;

function addDateFilter() {
  const f = {
    id: Date.now() + Math.random(),
    field: cloneObj(field.value),
    operator: cloneObj(operator.value),
  };
  switch (f.operator.value) {
    case ">=":
      f.value = esCalendar2Sql(value.value);
      f.valueView = value.value?.toLocaleDateString("es-AR");
      break;
    case "<=":
      f.value = esCalendar2SqlFechaHasta(value.value);
      f.valueView = value.value?.toLocaleDateString("es-AR");
      break;
  }
  filters.value.push(f);
  // Si tenías enableFilterMultiple para limpiar
  // if (props.enableFilterMultiple) {
  //   limpiaForm();
  // }
  return Promise.resolve();
}

async function runFilters() {
  if (filters.value.length > 1) {
    filters.value = [filters.value[filters.value.length - 1]];
  }
  await emit("search", false, true);
}

async function cleanFilter() {
  resetFilters();
  emit("cleanQuery");
  await emit("search");
}

function resetFilters() {
  filters.value = [];
  value.value = null;
  value2.value = null;
}

function getValueName(i) {
  const filter = cloneObj(filters.value[i]);
  const v = filter.value;
  if (filter.valueView) return filter.valueView;
  if (!v) return "";
  if (typeof v === "string") return v;
  const fieldCfg = filter.field;
  const fieldName = fieldCfg.field;
  if (fieldCfg.multiple) {
    const optionLabel = props.dropdown[filter.field.field].optionLabel;
    const arr = [];
    for (const idx in v) arr.push(v[idx][optionLabel]);
    return arr.join(", ");
  }
  return v[props.dropdown[fieldName]?.optionLabel];
}

function getInjectString(filters) {
  const filtersWithStringsToInject = [];
  for (const filterIndex in filters) {
    const item = filters[filterIndex];
    if (!Array.isArray(item.value)) continue;
    for (const nestededFilterIndex in filters[filterIndex].value) {
      if (item.value[nestededFilterIndex]?.injectString !== undefined)
        filtersWithStringsToInject.push(item.value[nestededFilterIndex]);
    }
  }
  return filtersWithStringsToInject.length > 0 ? filtersWithStringsToInject : false;
}

function stringifySearch(searchToStringfy, arrInjectStrings) {
  // si es objeto vacío, no retorna nada
  if (!Object.keys(searchToStringfy).length > 0) return;
  // si no tiene inject strings, retorna el search por defecto stringfiado
  if (arrInjectStrings === false) return JSON.stringify(searchToStringfy);

  let searchStringfided = JSON.stringify(searchToStringfy);
  // le quitamos la llave de cierre, para agregarle más datos a la búsqueda
  searchStringfided = searchStringfided.slice(0, -1);

  for (let index = 0; index < arrInjectStrings.length; index++) {
    searchStringfided = buildSearchStringfided(arrInjectStrings[index], searchStringfided);
    if (index + 1 === arrInjectStrings.length) {
      searchStringfided = searchStringfided + "}";
    }
  }
  return searchStringfided;
}

function buildSearchStringfided(filterItem, defaultSearch) {
  const onlyInjectString = "{" + filterItem.injectString;
  const needOr = determineIfNeedsLogicalOperator(filterItem, defaultSearch);
  //el "logicOperator":"OR" se agrega en caso de que el filtro que contiene el 'injectString' se usa conbinado con otro filtro dentro de sus mismo DropDown
  if (needOr !== false) return needOr;
  //si el filtro que contiene el 'injectString' es el único elegido de su DropDown, pero está siendo usado junto con otro filtro sacado de otro lugar, entra por aquí sin el "logicOperator":"OR"
  if (filters.value.length > 1) {
    let finalSearch = filterItem.injectString.slice(0, -2) + "}], " + defaultSearch.substring(1);
    finalSearch = removeEmptyFilters(finalSearch);
    return finalSearch;
  }
  //por descarte, si el filtro que contiene el 'injectString' está completamente solo, se usará solamente el "onlyInjectString" como search
  return onlyInjectString;
}

function determineIfNeedsLogicalOperator(filterItem, defaultSearch) {
  for (const index in filters.value) {
    const it = filters.value[index];
    if (!Array.isArray(it.value)) continue;
    if (
      it.value.some((sub) => "injectString" in sub) &&
      it.value.length > 1 &&
      filterItem?.injectString !== undefined
    ) {
      const filterWithLogicOperator =
        defaultSearch + "," + filterItem.injectString.slice(0, -2) + ',"logicOperator":"OR"}]';
      return filterWithLogicOperator;
    }
  }
  return false;
}

function getValue(i) {
  const filter = cloneObj(filters.value[i]);
  const v = filter.value;
  if (!v) return "";
  if (typeof v === "string") return v;
  const fieldCfg = cloneObj(filter.field);
  const fieldName = fieldCfg.field;
  if (fieldCfg.multiple) {
    const optionValue = props.dropdown[filter.field.field].optionValue;
    const arr = [];
    for (const valIndex in v) arr.push(v[valIndex][optionValue]);
    return arr;
  }
  return v[props.dropdown[fieldName].optionValue];
}

function getActiveFilter() {
  return new Promise(async (resolve) => {
    if (!props.enableFilterMultiple) {
      // if (typeof addFilter === "function") {
      await addFilter();
      // }
    }
    resolve();
  });
}

function getFiltersV1() {
  return new Promise(async (resolve) => {
    filters.value = [];
    await getActiveFilter();
    let currentFilters = {};
    const ops = { "=": "=", "<": "min", ">": "max", CONTAINS: "like" };
    for (const i in filters.value) {
      let field = filters.value[i].field.field;
      const operator = filters.value[i].operator.value;
      field = operator === "=" ? field : `${field}@_@${ops[operator]}`;
      currentFilters[field] = getValue(i);
    }
    resolve(currentFilters);
  });
}

function getFiltersV2() {
  return new Promise(async (resolve, reject) => {
    await getActiveFilter();
    let currentFilters = {};
    for (let i in filters.value) {
      let field = filters.value[i].field.field;
      let operator = filters.value[i]?.operator?.value;
      let value = getValue(i);
      if (!currentFilters[field]) currentFilters[field] = [];

      let options = { operator, value };
      if (filters.value[i].field.addFilter) options.addFilter = filters.value[i].field.addFilter;

      currentFilters[field].push(options);
    }
    resolve({
      search: stringifySearch(currentFilters, getInjectString(filters.value)),
    });
  });
}

defineExpose({
  getFiltersV2,
  getFiltersV1,
  filterChipCount,
  filters,
  value,
  limpiaForm,
  field,
  validateDates,
  setFiltersFromQuery,
  stringifySearch,
  addFilter,
  handleFilterAction,
  removeFilter,
  checkFiltersCompatibility,
});

function deleteNullProps(array, optionLabel) {
  const arrayWhitoutPropsNull = [];
  for (let i = 0; i < array.length; i++) {
    const obj = { ...array[i] };
    if (obj[optionLabel] !== null) arrayWhitoutPropsNull.push(obj);
  }
  return arrayWhitoutPropsNull;
}

function checkFiltersCompatibility() {
  let singleFilterInPreviusFilters = false;

  for (const filterIndex in filters.value) {
    for (const subFilterIndex in filters.value[filterIndex].value) {
      if (filters.value[filterIndex].value[subFilterIndex]?.singleFilter) {
        singleFilterInPreviusFilters = true;
      }
    }
    if (singleFilterInPreviusFilters === true && filters.value[filterIndex].value.length <= 1) {
      singleFilterInPreviusFilters = false;
    }
  }

  let singleFilterInCurrentFilter = false;
  if (Array.isArray(value.value)) {
    for (const valueIndex in value.value) {
      if (value.value[valueIndex]?.singleFilter) {
        singleFilterInCurrentFilter = true;
      }
    }
    if (singleFilterInCurrentFilter === true && value.value.length <= 1) {
      singleFilterInCurrentFilter = false;
    }
  }

  if (filters.value.length > 0) {
    if (singleFilterInPreviusFilters || singleFilterInCurrentFilter) {
      $toast?.open?.({
        message: "Filtros incompatibles",
        position: "top-right",
        type: "warning",
        duration: 10000,
      });
      return false;
    }
  }

  return true;
}

function removeEmptyFilters(filtersToClean) {
  let cleaned = [];
  filtersToClean.split("],").map((filter) => {
    if (!filter.includes('"operator":"IN","value":["NULL"]')) cleaned.push(filter);
  });
  cleaned = cleaned.join("], ");
  //si no tiene el corchete de cierre por habérselo quitado con el split, se lo agregamos nuevamente
  if (cleaned.charAt(cleaned.length - 1) !== "]") cleaned += "]";
  return "{" + cleaned;
}

function onDropdownHide(refName) {
  if (vm?.$refs?.[refName]) vm.$refs[refName].filterValue = "";
}

function getValueOptions(fieldKey) {
  const fieldObj = props.dropdown[fieldKey];
  if (!fieldObj) return [];
  return getUniqueOptions(
    deleteNullProps(fieldObj.options, fieldObj.optionLabel),
    fieldObj.optionValue
  );
}

function setFiltersFromQuery(queryString) {
  try {
    const parsed = JSON.parse(queryString);
    filters.value = [];

    for (const fieldKey in parsed) {
      const conditions = parsed[fieldKey];
      const fieldConfig = props.filtersFields.find((f) => f.field === fieldKey);
      if (!fieldConfig) continue;

      const dropdownOptions = props.dropdown?.[fieldKey]?.options || [];
      const optionValue = props.dropdown?.[fieldKey]?.optionValue;

      conditions.forEach(({ operator, value }) => {
        // Mantener búsqueda de operador por tipo de campo (como tu original)
        const operatorList =
          operators.value[fieldConfig.type || "default"] || operators.value.default;
        const operatorObj = operatorList.find((op) => op.value === operator);
        if (!operatorObj) return;

        // Mantener mapeo de dropdown SOLO para valor simple (como tu original)
        let finalValue = value;
        if (dropdownOptions.length && optionValue) {
          const match = dropdownOptions.find((opt) => opt[optionValue] === value);
          if (match) finalValue = match;
        }

        filters.value.push({
          field: fieldConfig,
          operator: operatorObj,
          value: finalValue,
        });
      });
    }

    emit("search");
  } catch (e) {
    console.error("Error al parsear filtros desde query:", e);
  }
}

function hasLimit() {
  if (field.value?.limit) {
    let count = 0;
    filters.value.map((e) => {
      if (e.field.name === field.value.name) count++;
    });
    if (count >= field.value.limit) {
      $toast?.open?.({
        message: "No se puede agregar mas de una opcion de ese filtro",
        position: "top-right",
        type: "warning",
        duration: 5000,
      });
      return true;
    }
  }
}

function removeFilter(id) {
  if (props.isLoading) return;
  filters.value = filters.value.filter((f) => f.id !== id);
  emit("search");
  emit("cleanQuery");
}
</script>

<style lang="scss" scoped>
.principal {
  display: flex;
  flex-wrap: wrap;
  max-width: 940px;
  .field {
    min-width: 200px;
  }
}
.title {
  font-weight: 600;
  font-size: 0.8em;
}
.itemSelect {
  color: var(--indigo-200);
  .filter-item {
    background-color: rgb(239, 246, 251);
    color: rgb(11, 81, 149);
    padding: 6px 12px;
    border-radius: 9999px;
  }
}
.transparent-button {
  background-color: transparent;
  color: #607d8b;
  border: 1px solid #607d8b;
}

.transparent-button:hover {
  background-color: rgba(96, 125, 139, 0.1);
  border: 1px solid #607d8b;
}

.search-button {
  height: 35px;
  gap: 10px;
  border-radius: 6px;
  background: #0b5195;
  color: #ffffff;
  border: 1px solid #0b5195;
  box-shadow: 0px 1px 3px 0px rgba(166, 175, 195, 0.4);
  margin-right: 0.5em;
}
.search-button:hover {
  background: #0b5195 !important;
  color: #f4f4f4 !important;
  opacity: 0.9;
  cursor: pointer;
}

.clean-button {
  height: 35px;
  justify-content: center;
  gap: 10px;
  border-radius: 6px;
  background: var(--White-White, #fff);
  color: #0b5195;
  border: 1px solid #0b5195;
  box-shadow: 0px 1px 3px 0px rgba(166, 175, 195, 0.4);
  font-size: 14px;
}
.clean-button:hover {
  background: #f4f4f4 !important;
  color: #0b5195 !important;
  opacity: 0.9;
  cursor: pointer;
}

::v-deep .p-chip .p-chip-remove-icon {
  color: red !important;
}

.principal ::v-deep(.p-inputtext),
.principal ::v-deep(.p-dropdown),
.principal ::v-deep(.p-multiselect),
.principal ::v-deep(.p-calendar),
.principal ::v-deep(.p-inputnumber) {
  border-radius: 6px !important;
}
</style>
